/**
 * Classify a Samsara vehicle as Van, Flatbed, or Trailer.
 * Prefers Samsara tag names (e.g. "Van Trucks", "Flatbed Trucks") over unit name/model.
 */
function collectTagLabels(vehicle) {
    if (!vehicle || typeof vehicle !== 'object') return [];
    const labels = [];
    const add = (value) => {
        if (value == null) return;
        const text = String(value).trim();
        if (text) labels.push(text);
    };
    const sources = [vehicle.tags, vehicle.tagNames, vehicle.vehicle?.tags];
    for (const source of sources) {
        if (!Array.isArray(source)) continue;
        for (const entry of source) {
            if (typeof entry === 'string') add(entry);
            else if (entry && typeof entry === 'object') {
                add(entry.name || entry.label || entry.tagName);
            }
        }
    }
    return labels;
}

function typeFromTagLabel(label) {
    const normalized = String(label || '').trim().toLowerCase();
    if (!normalized) return null;
    if (normalized.includes('trailer')) return 'Trailer';
    if (normalized.includes('flatbed') || (normalized.includes('flat') && normalized.includes('truck'))) {
        return 'Flatbed';
    }
    if (normalized.includes('van')) return 'Van';
    return null;
}

export function mapSamsaraVehicleType(vehicle) {
    const tagLabels = collectTagLabels(vehicle);
    if (tagLabels.length > 0) {
        let sawVan = false;
        for (const label of tagLabels) {
            const fromTag = typeFromTagLabel(label);
            if (fromTag === 'Trailer') return 'Trailer';
            if (fromTag === 'Flatbed') return 'Flatbed';
            if (fromTag === 'Van') sawVan = true;
        }
        if (sawVan) return 'Van';
    }

    const name = String(
        vehicle?.name || vehicle?.serial || vehicle?.label || vehicle?.unitNumber || ''
    ).toLowerCase();
    const model = String(vehicle?.model || vehicle?.vehicleModel || '').toLowerCase();

    if (name.includes('trailer') || model.includes('trailer')) return 'Trailer';
    if (name.includes('flatbed') || model.includes('flatbed') || name.includes('flat') || model.includes('flat')) {
        return 'Flatbed';
    }
    if (name.includes('van') || model.includes('van')) return 'Van';
    return 'Van';
}
